<template>
  <div class="header__container" @touchstart="touchHeader">
    <div class="giftee-header" :class="{ 'is-not-logged-in': !isLoggedIn }">
      <div
        class="side-menu-closer"
        :class="{ 'is-not-logged-in': !isLoggedIn }"
      >
        <div class="nav__hamburger">
          <div class="side-menu__icon" @click="onClickMenuIcon">
            <ImgLazy
              :image-url="hamburgerImage"
              aspect-ratio="1"
              :width="28"
              :height="28"
              alt-text="hamburger"
            />
          </div>
          <div
            :class="{
              'side-menu__content--background-wrapper': !showableSideMenu,
              'side-menu__content--background-wrapper--active': showableSideMenu
            }"
            @click="toggleSideMenu"
          />
          <SideMenu
            :showable-side-menu="showableSideMenu"
            :is-logged-in="isLoggedIn"
            :nickname="currentUserNickname"
            :has-profile="hasProfile"
            :profile-description="profileDescription"
            :link-url="linkUrl"
            :icon-image-url="iconImageUrl"
          />
        </div>
      </div>
      <h1 class="nav__logo">
        <a href="/">
          <ImgLazy
            :image-url="logoImage"
            alt-text="logo"
            aspect-ratio="80 / 24"
            :height="24"
            :width="80"
            class="logo-image-container"
          />
        </a>
      </h1>
      <div v-if="!isLoggedIn" class="nav__account">
        <a
          class="body-bold"
          href="/barista/sessions/new"
          @click="clickSignInLink"
        >
          ログイン
        </a>
        <a
          class="body-bold"
          href="/barista/registrations/new"
          @click="clickSignUpLink"
        >
          新規登録
        </a>
      </div>
      <div v-else class="nav__login-account">
        <a :href="linkUrl">
          <div class="nav-login-user">
            <AccountIconWh24 :image-url="iconImageUrl" />
            <p class="nav-login-user__nickname">{{ currentUserNickname }}</p>
          </div>
        </a>
      </div>
      <div class="nav__bookmark" @click="onClickBookmarkIcon">
        <div class="nav-icon-container">
          <ImgLazy
            :image-url="bookmarkBlackImage"
            alt-text="ブックマーク"
            aspect-ratio="1"
            :width="24"
            :height="24"
            image-class="nav-button--bookmark"
          />
        </div>
      </div>
      <div class="nav__bell" @click="onClickBellIcon">
        <div class="nav-icon-container">
          <ImgLazy
            :image-url="bellBlackImage"
            alt-text="通知"
            aspect-ratio="1"
            :width="24"
            :height="24"
            image-class="nav-button--bell"
          />
        </div>
        <span v-if="notificationPageUnread" class="unread-mark" />
      </div>
      <div v-if="isGiftCardSessionEditing" class="nav__create-wrapper">
        <div class="nav__create" @click="showModal">
          <ImgLazy
            :image-url="createGiftImage"
            alt-text="create_gift"
            aspect-ratio="1"
            :width="24"
            :height="24"
            image-class="nav-button--create"
          />
          <span class="gift-card-editing-mark" />
        </div>
        <TextModalWithSecondary
          v-if="isModalActive"
          :title-text="modalText.title"
          :caption-text="modalText.caption"
          :primary-button-text="modalText.primaryButton"
          :secondary-button-text="modalText.secondaryButton"
          :cancel-button-text="modalText.cancelButton"
          @clicked-modal-cover="closeModal"
          @clicked-primary="onClickPrimaryButton('/gift_card/new')"
          @clicked-secondary="clickedSecondaryButton('/gift_card/edit')"
          @clicked-cancel="closeModal"
        />
      </div>
      <div v-else class="nav__create-wrapper">
        <div class="nav__create">
          <a href="/gift_card/new" @click="sendCreateGiftImageDataLayer">
            <ImgLazy
              :image-url="createGiftImage"
              alt-text="create_gift"
              aspect-ratio="1"
              :width="24"
              :height="24"
              image-class="nav-button--create"
            />
          </a>
        </div>
      </div>
      <div class="nav__search">
        <div class="nav__search--wrap">
          <SearchInputForm
            :value="keyword"
            :placeholder="searchPlaceholder"
            @input-search-keyword="onInputSearchText"
            @on-focus="onFocusSearchText"
            @on-blur="onBlurSearchText"
            @clicked-search-keyword="onClickSearchKeyword"
            @clicked-clear-keyword="onClickClearKeyword"
          />
          <button
            v-show="canShowSuggestedKeywords"
            class="suggest__cancel"
            @click="hideSuggestKeyword"
          >
            キャンセル
          </button>
        </div>
        <SuggestListForPc
          v-show="isPc()"
          :can-show-suggested-keywords="canShowSuggestedKeywords"
          :suggested-keywords="suggestedItemKeywords"
          @click-suggested-keyword="onClickSuggestedKeyword"
        />
      </div>
    </div>
    <SuggestListForSp
      v-show="isSp()"
      :can-show-suggested-keywords="canShowSuggestedKeywords"
      :suggested-keywords="suggestedItemKeywords"
      @click-suggested-keyword="onClickSuggestedKeyword"
    />
  </div>
</template>
<script>
import qs from 'qs'
import url from 'url'
import TextModalWithSecondary from '../../molecules/modals/with_secondary/text-modal-with-secondary.vue'
import SideMenu from './SideMenu.vue'
import SearchInputForm from '../../molecules/input_forms/SearchInputForm.vue'
import hamburger from '../../../../../images/buttons/hamburger.svg'
import createGift from '../../../../../images/buttons/create_gift.svg'
import bookmarkOutlineBlack from '../../../../../images/buttons/bookmark-outline-black.svg'
import bellBlack from '../../../../../images/buttons/bell-black.svg'
import logo from '../../../../../images/logo.svg'
import AccountIconWh24 from '../../atoms/account_icons/AccountIconWh24.vue'
import SuggestListForPc from '../../molecules/suggest_list/SuggestListForPc.vue'
import SuggestListForSp from '../../molecules/suggest_list/SuggestListForSp.vue'
import FetchSuggestedItemKeywordsQuery from '../../../../../graphqls/public/queries/fetch_suggested_item_keywords'
import * as Sentry from '@sentry/browser'
import { debounce } from 'lodash'
import ImgLazy from '../../atoms/images/ImgLazy.vue'

const SUGGEST_DEBOUNCE_TIME = 400
const SUGGESTLIST_CLOSE_TIME = 200
const SP_SIZE_WIDTH = 768

export default {
  components: {
    AccountIconWh24,
    TextModalWithSecondary,
    SideMenu,
    SuggestListForPc,
    SuggestListForSp,
    SearchInputForm,
    ImgLazy
  },
  props: {
    isLoggedIn: {
      type: Boolean,
      required: true
    },
    currentUserNickname: {
      type: String,
      required: true
    },
    hasProfile: {
      type: Boolean,
      required: true
    },
    profileDescription: {
      type: String,
      required: false,
      default: null
    },
    linkUrl: {
      type: String,
      required: true
    },
    iconImageUrl: {
      type: String,
      required: true
    },
    isGiftCardSessionEditing: {
      type: Boolean,
      required: true
    },
    notificationPageUnread: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      isModalActive: false,
      modalText: {
        title: '作成中のギフトカードがあります',
        caption:
          '作成できるカードは１つまでです。\n内容を破棄して新規作成しますか?',
        primaryButton: '新規作成する',
        secondaryButton: 'カードを確認する',
        cancelButton: '閉じる'
      },
      showableSideMenu: false,
      logoImage: '',
      hamburgerImage: '',
      createGiftImage: '',
      bookmarkBlackImage: '',
      bellBlackImage: '',
      keyword: '',
      sortKey: 'recommended',
      showSuggestKeywords: false,
      suggestedItemKeywords: [],
      lowerBudget: null,
      higherBudget: null,
      categoryIds: [],
      sceneIds: [],
      receivingKindIds: []
    }
  },
  computed: {
    isKeywordInputted() {
      return this.keyword.trim().length !== 0
    },
    canShowSuggestedKeywords() {
      return this.suggestedItemKeywords.length > 0 && this.showSuggestKeywords
    },
    searchPlaceholder() {
      return 'キーワード検索 （例）チョコ、スープ'
    }
  },
  mounted() {
    this.hamburgerImage = hamburger
    this.createGiftImage = createGift
    this.bookmarkBlackImage = bookmarkOutlineBlack
    this.bellBlackImage = bellBlack
    this.logoImage = logo
    this.setSearchParamsFromUrl() // URLのパラメータから現状の検索条件の取得
  },
  methods: {
    isSp() {
      return window.innerWidth <= SP_SIZE_WIDTH
    },
    isPc() {
      return window.innerWidth > SP_SIZE_WIDTH
    },
    touchHeader() {
      // 以下の場合、何かしら画面上を触ったらソフトウェアキーボードを非表示するために、blurを行う
      // - 「SPサイズの場合」 かつ 「サジェストを表示している場合」
      if (this.canShowSuggestedKeywords && this.isSp()) {
        document.activeElement.blur()
      }
    },
    setSearchParamsFromUrl(isUpdateKeyword = true) {
      const urlQuery = url.parse(location.href).query
      if (!urlQuery) {
        return
      }
      const parsed = qs.parse(urlQuery)
      this.sortKey = parsed.sort_key ? parsed.sort_key : 'recommended'

      if (isUpdateKeyword) {
        this.keyword = parsed.keyword ? parsed.keyword : ''
      }
      this.lowerBudget = parsed.lower_budget
        ? Number(parsed.lower_budget)
        : null
      this.higherBudget = parsed.higher_budget
        ? Number(parsed.higher_budget)
        : null
      this.categoryIds = parsed.category_ids
        ? parsed.category_ids.map(categoryId => Number(categoryId))
        : []
      this.sceneIds = parsed.scene_ids
        ? parsed.scene_ids.map(sceneId => Number(sceneId))
        : []
      this.receivingKindIds =
        parsed.item_receiving_kinds && parsed.item_receiving_kinds
          ? parsed.item_receiving_kinds.map(itemReceivingKindId =>
              Number(itemReceivingKindId)
            )
          : []

      // ========== 特集等で旧パラメータ(category_id/scene_id)を利用している場合に対応するために記載 ==========
      const selectedCategoryId = parsed.category_id
        ? Number(parsed.category_id)
        : null
      if (selectedCategoryId !== null) {
        this.categoryIds = [selectedCategoryId]
      }

      const selectedSceneId = parsed.scene_id ? Number(parsed.scene_id) : null
      if (selectedSceneId !== null) {
        this.sceneIds = [selectedSceneId]
      }
    },
    onClickBookmarkIcon() {
      dataLayer.push({
        event: 'click_header__bkmk_list'
      })
      location.href = '/mypage/item_sku_bookmarks'
    },
    onClickBellIcon() {
      dataLayer.push({
        event: 'click_header__news'
      })
      location.href = '/notifications'
    },
    sendCreateGiftImageDataLayer() {
      dataLayer.push({
        event: 'click_header__create_gift'
      })
    },
    showModal() {
      this.sendCreateGiftImageDataLayer()
      this.isModalActive = true
    },
    closeModal() {
      this.isModalActive = false
    },
    onInputSearchText(keyword) {
      // 前と同じキーワードの場合は、スキップ
      if (this.keyword == keyword) return

      this.keyword = keyword
      if (this.keyword.length === 0) {
        this.suggestedItemKeywords = []
        return
      }

      // サジェストリストの取得
      this.fetchSuggestKeyword(this.keyword)
    },
    onFocusSearchText() {
      this.showSuggestKeywords = true
    },
    onBlurSearchText() {
      // PCサイズの場合は、検索窓のBlur時にサジェストを非表示に
      if (this.isPc()) {
        // 即座に実行すると、サジェストの結果をクリック前に非表示になってしまうため、非表示するのを少し待つように
        setTimeout(() => {
          this.showSuggestKeywords = false
        }, SUGGESTLIST_CLOSE_TIME)
      }
    },
    onClickPrimaryButton(url) {
      this.moveToUrl(url)
    },
    clickedSecondaryButton(url) {
      this.moveToUrl(url)
    },
    moveToUrl(url) {
      location.href = url
      this.closeModal()
    },
    onClickMenuIcon() {
      dataLayer.push({
        event: 'click_header__menu'
      })
      this.toggleSideMenu()
    },
    toggleSideMenu() {
      this.showableSideMenu = !this.showableSideMenu
      this.toggleBodyClassList()
    },
    toggleBodyClassList() {
      document.body.classList.toggle('side-menu-active')
    },
    clickSignUpLink() {
      dataLayer.push({
        event: 'signup_click',
        button: 'header'
      })
    },
    clickSignInLink() {
      dataLayer.push({
        event: 'signin_click',
        button: 'header'
      })
    },
    search() {
      // 絞り込みを変更したときにURLのパラメータが変更される。そのため検索前に再度URLのパラメータから検索条件を取得する
      // また、検索時は入力中のキーワードを利用するため、キーワードはURL中のものを利用しないようにfalseを指定
      this.setSearchParamsFromUrl(false)
      const params = this.createParamsObjectFromData()
      const paramsString = qs.stringify(params, { arrayFormat: 'brackets' })
      window.location.href = `/items?${paramsString}`
    },
    onClickSearchKeyword() {
      this.search()
    },
    createParamsObjectFromData() {
      const keyword = this.keyword ? { keyword: this.keyword } : {}
      const sortKey =
        this.sortKey !== 'recommended' ? { sort_key: this.sortKey } : {}
      const lowerBudget = this.lowerBudget
        ? { lower_budget: this.lowerBudget }
        : {}
      const higherBudget = this.higherBudget
        ? { higher_budget: this.higherBudget }
        : {}
      const categoryIds = this.categoryIds
        ? { category_ids: this.categoryIds }
        : {}
      const sceneIds = this.sceneIds ? { scene_ids: this.sceneIds } : {}
      const itemReceivingKinds = this.receivingKindIds
        ? { item_receiving_kinds: this.receivingKindIds }
        : {}
      return Object.assign(
        {},
        sortKey,
        lowerBudget,
        higherBudget,
        categoryIds,
        sceneIds,
        itemReceivingKinds,
        keyword
      )
    },
    onClickClearKeyword() {
      this.keyword = ''
      this.suggestedItemKeywords = []
      this.search()
    },
    fetchSuggestKeyword: debounce(async function(keyword) {
      // リクエスト前にすでにキーワードがない場合はリクエストしない
      if (!this.isKeywordInputted) return

      try {
        const response = await this.$apollo.provider.clients.publicClient.query(
          {
            query: FetchSuggestedItemKeywordsQuery,
            variables: {
              keyword: keyword
            }
          }
        )
        if (this.isKeywordInputted) {
          this.suggestedItemKeywords = response.data.suggestedItemKeywords
        } else {
          // リクエストが返ってきた時に、キーワードがない場合はサジェスト内容を空にする
          this.suggestedItemKeywords = []
        }
      } catch (error) {
        Sentry.captureException(error)
      }
    }, SUGGEST_DEBOUNCE_TIME),
    onClickSuggestedKeyword(keyword) {
      this.keyword = keyword
      this.onClickSearchKeyword()
      this.suggestedItemKeywords = []
    },
    hideSuggestKeyword() {
      this.showSuggestKeywords = false
    }
  }
}
</script>
